import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAccountSide = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      stroke="#454655"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.982 21.81a4.2 4.2 0 0 1 3.868-2.56h6.3a4.2 4.2 0 0 1 3.868 2.56M18.2 11.375a4.2 4.2 0 1 1-8.4 0 4.2 4.2 0 0 1 8.4 0M24.5 14c0 5.799-4.701 10.5-10.5 10.5S3.5 19.799 3.5 14 8.201 3.5 14 3.5 24.5 8.201 24.5 14"
    />
  </svg>
);
export default SvgAccountSide;
